export const REWARD_LABELS = [
    'Aquarius AMM daily reward',
    'SDEX daily reward',
    'Total daily reward',
];
